import React from 'react'
import { Link } from 'gatsby'
import { useDispatch } from 'react-redux'

import scrollManager from '~/utils/scrollManager'

import { ArrowRight } from '~/icons/ArrowRight'

import { setHasProfileNavOpen, setHasMainNavOpen } from '~/store/actions'

const DirectLink = ({ text, link, navType, contentType = false }) => {
  const dispatch = useDispatch()

  const click = () => {
    if (navType === 'mainNav') {
      dispatch(setHasMainNavOpen(false))
    } else {
      dispatch(setHasProfileNavOpen(false))
    }

    scrollManager.restart()
  }

  return (
    <Wrapper
      contentType={contentType}
      navType={navType}
      click={click}
      link={link}
    >
      <span className="main-nav-link__txt">{text}</span>

      <span className="main-nav-link__icon">
        <ArrowRight className="icon-white" />
      </span>
    </Wrapper>
  )
}

const Wrapper = ({ contentType, click, children, link, navType }) => {
  return (
    <>
      {contentType === 'ContentfulSimulator' ||
      contentType === 'ContentfulContact' ? (
        <a
          href={link}
          className={`main-nav-link ${navType !== 'mainNav' ? 'main-nav-link--profile' : ''}`}
          onClick={click}
        >
          {children}
        </a>
      ) : (
        <Link
          to={link}
          className={`main-nav-link ${navType !== 'mainNav' ? 'main-nav-link--profile' : ''}`}
          onClick={click}
        >
          {children}
        </Link>
      )}
    </>
  )
}

export default DirectLink
